<!-- @veltra/icons generated sha256:9fe04dcadd2090f6 gen:8 source:src/svg/normal/user.svg -->
<script setup lang="ts">
defineOptions({ name: 'User' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M11.5 5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m3.463 5.853a.96.96 0 0 1 .537.872V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-2.275a.96.96 0 0 1 .537-.872A13.8 13.8 0 0 1 8 9.5c2.133 0 4.15.487 5.963 1.353M8 10.5c-1.967 0-3.826.446-5.5 1.24v1.258c0 .276.215.502.49.502h10.02c.275 0 .49-.226.49-.502V11.74A12.8 12.8 0 0 0 8 10.5"
    />
  </svg>
</template>
